import { FC, useState } from 'react';
import classNames from 'classnames';
import { Tooltip } from 'common-components';
import { CheckIcon, LanguageIcon, ClickAwayListener, ExpandLess, ExpandMore } from '../uiLibraryImports';
import { useTranslationContext } from '../contexts/translationContext';
import { SelectLanguageProps } from './selectLanguageType';
import styles from './selectLanguage.module.scss';

const languagesList = [
    { title: 'Deutsch', value: 'de' },
    { title: 'English', value: 'en' },
    { title: 'Español', value: 'es' },
    { title: 'Français', value: 'fr' },
    { title: 'Português', value: 'pt' },
    { title: '日本語', value: 'ja' },
    { title: '한국어', value: 'ko' }
];

const SelectLanguage: FC<SelectLanguageProps> = (props: SelectLanguageProps) => {
    const { userLocale, setUserLocale } = props;
    const { translate } = useTranslationContext();

    const [isOptionsOpen, setIsOptionsOpen] = useState<boolean>(false);
    const localeDisplayName = languagesList.find(item => item.value === userLocale)?.title;

    const onSelectLanguage = (language: string) => {
        setUserLocale(language);
        setIsOptionsOpen(false);
    };

    return (
        <div className={styles['select-language-wrapper']}>
            <Tooltip hasBorder unsetMaxWidth hasDefaultStyle title={translate('SystemAndContentLanguageWhenAvailable')}>
                <div
                    className={classNames(styles['selected-language'], {
                        [styles['selected-language-active']]: isOptionsOpen
                    })}
                    onClick={() => setIsOptionsOpen(!isOptionsOpen)}
                >
                    <LanguageIcon fontSize="small" />
                    <div className={styles.language}>{localeDisplayName}</div>
                    {isOptionsOpen ? <ExpandLess /> : <ExpandMore />}
                </div>
            </Tooltip>
            {isOptionsOpen && (
                <ClickAwayListener onClickAway={() => setIsOptionsOpen(false)}>
                    <div className={styles.options}>
                        {languagesList.map((language, i) => {
                            const isSelectedOption = userLocale === language.value;
                            const isLastOption = i === languagesList.length - 1;
                            return (
                                <div
                                    key={i}
                                    className={classNames(styles.option, {
                                        [styles['clicked-option']]: isSelectedOption,
                                        [styles['bottom-border']]: !isLastOption
                                    })}
                                    onClick={() => onSelectLanguage(language.value)}
                                >
                                    <div>{language.title}</div>
                                    {isSelectedOption && <CheckIcon data-testid="check-icon" fontSize="small" />}
                                </div>
                            );
                        })}
                    </div>
                </ClickAwayListener>
            )}
        </div>
    );
};

export default SelectLanguage;
